const TYPES = {
  EI: "EI",
  EF: "EF",
  EM: "EM",
  OLYMPIC: "OLYMPIC",
  ALL: "ALL"
}

const LISTGAMES = {
  [TYPES.EF]: {
    "1": [
      "rushhour"
    ],
    "2": [
      "domino"
    ],
    "3": [
      "battlesubmarine"
    ],
    "4": [
      "rushhour",
      "minibridge"
    ],
    "5": [
      "yams"
    ],
    "6": [
      "rushhour",
      "minibridge"
    ],
    "7": [
      "yams"
    ],
    "8": [
      "gamao"
    ],
    "9": [
    ]
  },
  [TYPES.EI]: {
    "4": [
      "rushhour"
    ],
    "5": [
    ]
  },
  [TYPES.EM]: [
    "rushhour"
  ],
  [TYPES.OLYMPIC]: [
    "abalone",
    "checkers",
    "octi",
    "quoridor"
  ],
  [TYPES.ALL]: [
      "rushhour",
      "minibridge",
      "gamao",
      "battlesubmarine",
      "domino",
      "yams"
  ]
}

export function getOlympicGames() {
  return LISTGAMES[TYPES.OLYMPIC]
}

export function getActiveGames() {
  return LISTGAMES[TYPES.ALL]
}

export function getGamesByType(type, year = null) {
  return (Object.values(TYPES).indexOf(type) === -1)
    ? null
    : (type !== TYPES.EF && type !== TYPES.EI)
      ? LISTGAMES[type]
      : LISTGAMES[type][year]
}
